function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/mergeoperation
 */
import Operation from './operation';
import SplitOperation from './splitoperation';
import Position from '../position';
import Range from '../range';
import { _move } from './utils';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Operation to merge two {@link module:engine/model/element~Element elements}.
 *
 * The merged element is the parent of {@link ~MergeOperation#sourcePosition} and it is merged into the parent of
 * {@link ~MergeOperation#targetPosition}. All nodes from the merged element are moved to {@link ~MergeOperation#targetPosition}.
 *
 * The merged element is moved to the graveyard at {@link ~MergeOperation#graveyardPosition}.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var MergeOperation = /*#__PURE__*/function (_Operation) {
  _inherits(MergeOperation, _Operation);

  var _super = _createSuper(MergeOperation);

  /**
   * Creates a merge operation.
   *
   * @param {module:engine/model/position~Position} sourcePosition Position inside the merged element. All nodes from that
   * element after that position will be moved to {@link ~#targetPosition}.
   * @param {Number} howMany Summary offset size of nodes which will be moved from the merged element to the new parent.
   * @param {module:engine/model/position~Position} targetPosition Position which the nodes from the merged elements will be moved to.
   * @param {module:engine/model/position~Position} graveyardPosition Position in graveyard to which the merged element will be moved.
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function MergeOperation(sourcePosition, howMany, targetPosition, graveyardPosition, baseVersion) {
    var _this;

    _classCallCheck(this, MergeOperation);

    _this = _super.call(this, baseVersion);
    /**
     * Position inside the merged element. All nodes from that element after that position will be moved to {@link ~#targetPosition}.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/mergeoperation~MergeOperation#sourcePosition
     */

    _this.sourcePosition = sourcePosition.clone(); // This is, and should always remain, the first position in its parent.

    _this.sourcePosition.stickiness = 'toPrevious';
    /**
     * Summary offset size of nodes which will be moved from the merged element to the new parent.
     *
     * @member {Number} module:engine/model/operation/mergeoperation~MergeOperation#howMany
     */

    _this.howMany = howMany;
    /**
     * Position which the nodes from the merged elements will be moved to.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/mergeoperation~MergeOperation#targetPosition
     */

    _this.targetPosition = targetPosition.clone(); // Except of a rare scenario in `MergeOperation` x `MergeOperation` transformation,
    // this is, and should always remain, the last position in its parent.

    _this.targetPosition.stickiness = 'toNext';
    /**
     * Position in graveyard to which the merged element will be moved.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/mergeoperation~MergeOperation#graveyardPosition
     */

    _this.graveyardPosition = graveyardPosition.clone();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MergeOperation, [{
    key: "type",
    get: function get() {
      return 'merge';
    }
    /**
     * Position before the merged element (which will be deleted).
     *
     * @readonly
     * @type {module:engine/model/position~Position}
     */

  }, {
    key: "deletionPosition",
    get: function get() {
      return new Position(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
    }
    /**
     * Artificial range that contains all the nodes from the merged element that will be moved to {@link ~MergeOperation#sourcePosition}.
     * The range starts at {@link ~MergeOperation#sourcePosition} and ends in the same parent, at `POSITIVE_INFINITY` offset.
     *
     * @readonly
     * @type {module:engine/model/range~Range}
     */

  }, {
    key: "movedRange",
    get: function get() {
      var end = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
      return new Range(this.sourcePosition, end);
    }
    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/mergeoperation~MergeOperation} Clone of this operation.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/splitoperation~SplitOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      // Positions in this method are transformed by this merge operation because the split operation bases on
      // the context after this merge operation happened (because split operation reverses it).
      // So we need to acknowledge that the merge operation happened and those positions changed a little.
      var targetPosition = this.targetPosition._getTransformedByMergeOperation(this);

      var path = this.sourcePosition.path.slice(0, -1);

      var insertionPosition = new Position(this.sourcePosition.root, path)._getTransformedByMergeOperation(this);

      return new SplitOperation(targetPosition, this.howMany, insertionPosition, this.graveyardPosition, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_validate",
    value: function _validate() {
      var sourceElement = this.sourcePosition.parent;
      var targetElement = this.targetPosition.parent; // Validate whether merge operation has correct parameters.

      if (!sourceElement.parent) {
        /**
         * Merge source position is invalid. The element to be merged must have a parent node.
         *
         * @error merge-operation-source-position-invalid
         */
        throw new CKEditorError('merge-operation-source-position-invalid', this);
      } else if (!targetElement.parent) {
        /**
         * Merge target position is invalid. The element to be merged must have a parent node.
         *
         * @error merge-operation-target-position-invalid
         */
        throw new CKEditorError('merge-operation-target-position-invalid', this);
      } else if (this.howMany != sourceElement.maxOffset) {
        /**
         * Merge operation specifies wrong number of nodes to move.
         *
         * @error merge-operation-how-many-invalid
         */
        throw new CKEditorError('merge-operation-how-many-invalid', this);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      var mergedElement = this.sourcePosition.parent;

      var sourceRange = Range._createIn(mergedElement);

      _move(sourceRange, this.targetPosition);

      _move(Range._createOn(mergedElement), this.graveyardPosition);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(MergeOperation.prototype), "toJSON", this).call(this);

      json.sourcePosition = json.sourcePosition.toJSON();
      json.targetPosition = json.targetPosition.toJSON();
      json.graveyardPosition = json.graveyardPosition.toJSON();
      return json;
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "className",
    get: function get() {
      return 'MergeOperation';
    }
    /**
     * Creates `MergeOperation` object from deserilized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/mergeoperation~MergeOperation}
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json, document) {
      var sourcePosition = Position.fromJSON(json.sourcePosition, document);
      var targetPosition = Position.fromJSON(json.targetPosition, document);
      var graveyardPosition = Position.fromJSON(json.graveyardPosition, document);
      return new this(sourcePosition, json.howMany, targetPosition, graveyardPosition, json.baseVersion);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `MergeOperation( ${ this.baseVersion } ): ` +
    // @if CK_DEBUG_ENGINE //		`${ this.sourcePosition } -> ${ this.targetPosition }` +
    // @if CK_DEBUG_ENGINE //		` ( ${ this.howMany } ), ${ this.graveyardPosition }`;
    // @if CK_DEBUG_ENGINE // }

  }]);

  return MergeOperation;
}(Operation);

export { MergeOperation as default };